<template>
  <!-- Commande d'échange ↔ retour des matériels d'origine : chaque fiche renvoie à l'autre, et
       indique pour chaque référence d'origine celle qui la remplace (SFD Échanges et stockage 1.1). -->
  <div v-if="exchange" class="ibox exchange-banner">
    <div class="ibox-title">
      <i class="far fa-exchange"></i>
      <template v-if="context == 'renting'">
        Commande d'échange
        <span class="exchange-banner__linked">
          Retour des matériels d'origine :
          <router-link :to="{ name: 'BusinessReturnDetail', params: { id: exchange.business_return.id } }">{{ exchange.business_return.number }}</router-link>
          <b-badge :variant="exchange.business_return.status.slug == 'business-return-annule' ? 'danger' : 'primary'">{{ exchange.business_return.status.name }}</b-badge>
        </span>
      </template>
      <template v-else>
        Retour d'échange
        <span class="exchange-banner__linked">
          Commande de remplacement :
          <router-link :to="{ name: 'RentingDetail', params: { id: exchange.renting.id } }">{{ exchange.renting.number }}</router-link>
          <b-badge variant="primary">{{ exchange.renting.status.name }}</b-badge>
        </span>
      </template>
    </div>
    <div class="ibox-content">
      <p v-if="context != 'renting'" class="exchange-banner__note">
        <i class="far fa-info-circle mr-10"></i>Facturation arrêtée au scan de réception, quel que soit le mode de retour.
      </p>
      <div class="table-wrapper">
        <table class="table exchange-banner__table">
          <thead>
            <tr>
              <th>Produit</th>
              <th>Matériel d'origine</th>
              <th class="exchange-banner__arrow"></th>
              <th>Remplacement</th>
              <th>Tarification depuis le</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="line in exchange.lines" :key="line.original_reference.id">
              <td>
                <router-link :to="{ name: 'ProductDetail', params: { id: line.product.id } }">{{ line.product.name }}</router-link>
              </td>
              <td>
                <router-link :to="{ name: 'ReferenceDetail', params: { id: line.original_reference.id } }">
                  <strong>{{ line.original_reference.internal_code }}</strong>
                </router-link>
              </td>
              <td class="exchange-banner__arrow"><i class="far fa-long-arrow-right"></i></td>
              <td>
                <router-link v-if="line.replacement_reference" :to="{ name: 'ReferenceDetail', params: { id: line.replacement_reference.id } }">
                  <strong>{{ line.replacement_reference.internal_code }}</strong>
                </router-link>
                <b-badge v-else variant="warning">À préparer</b-badge>
              </td>
              <td>{{ line.pricing_reference_date | moment("DD-MM-YYYY") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExchangeBanner",
  props: {
    // 'renting' : fiche commande ; 'return' : fiche retour.
    context: { type: String, required: true },
    id: { type: [Number, String], required: true },
  },
  data() {
    return { exchange: null };
  },
  watch: {
    id: "load",
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      if (!this.$root.isAuthorized("exchange_index")) {
        return;
      }
      const params = this.context == "renting" ? { renting: this.id } : { business_return: this.id };
      this.$http
        .get(process.env.BACK_API_URL + "exchange", { params })
        .then((response) => {
          const exchanges = (response.data && response.data.exchanges) || [];
          this.exchange = exchanges.length ? exchanges[0] : null;
        })
        .catch(() => {
          this.exchange = null;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

/* Lien vers la fiche jumelle (retour ↔ commande), à droite du titre. */
.exchange-banner__linked {
  float: right;
  text-transform: none;
  letter-spacing: 0;
  font-weight: normal;

  .badge {
    margin-left: 8px;
  }
}

.exchange-banner__note {
  margin: 0 0 15px;
  font-size: 12px;
  color: $text-50p;
}

.exchange-banner__table {
  margin-bottom: 0;
  font-size: 12px;

  th,
  td {
    vertical-align: middle;
  }
}

/* Flèche origine → remplacement : colonne étroite, centrée. */
.exchange-banner__arrow {
  width: 30px;
  text-align: center;
  color: $primary;
}
</style>



// WEBPACK FOOTER //
// src/components/Exchange/ExchangeBanner.vue